<script setup lang="ts">
const route = useRoute()
const { locale }  = useI18n()

const runtimeConfig = useRuntimeConfig()

const previewSecret = runtimeConfig?.previewSecret || runtimeConfig?.public?.previewSecret
const isPreview = computed(() => route?.query?.previewSecret === previewSecret)

const { data, error } = await useAsyncData<ApplyPage>(
  () => `apply-page-${locale.value}`,
  () => {
    const query = GlobalApplyPageQuery
    return $fetch<ApplyPage>('/api/payload-gql', {
      method: 'POST',
      body: {
        query,
        variables: {
          locale: locale.value,
          isPreview: isPreview.value,
        },
        isPreview: isPreview.value,
      },
    })
  }
)

if (error.value) {
  throw createError({
    statusCode: 500,
    statusMessage: `Error fetching page`,
  })
}

usePageSeo({
  title: () => data.value?.title || 'Apply',
})

const pageNav = computed(() => usePageNavigation(data.value?.content))
</script>

<template>
  <page-layout>
    <template #header>
      <page-header
        :title="data?.title || 'Apply'"
        :route="{
          name: 'slug',
          title: data?.title,
          slug: slug,
        }"
        :include-breadcrumbs="true"
        :page-nav="pageNav"
      />
    </template>

    <template #default>
      <pages-apply
        v-if="data"
        :data="data"
      />
    </template>
  </page-layout>
</template>
